import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import "./../../styles/selfServiceStyles.css";
import {CommandContext, ScreenFormatContext} from "@mnjsplatform/data";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import SelfServiceFrame from "./SelfServiceFrame";
import {errorRaised} from "@mnjsplatform/data/lib/actions/errorActions";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";

class SelfService extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isDataReady: false,
            showMessage: false,
            messageText: ""
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            this.setState({isDataReady: false});
            try {
                await this.props.dispatch(this.props.dataItem_List.reset());
                await this.props.dispatch(this.props.dataItem_List.initialize({}, {
                    withParams: false,
                    withStyle: false
                }));
            } catch (e) {
                console.error(e);
            }
        } finally {
            this.setState({isDataReady: true})
        }
    }

    onSend = async () => {
        const errorFrames = this.props.dataItem_List.rawData.DataTable.filter((row) => row.IsView === 1 && !row.PageStatusText).sort((a, b) => (a.OrderPos - b.OrderPos));
        let errorText = i18next.t("SelfService_2");
        if (errorFrames.length > 0) {
            errorFrames.forEach((row, rowIndex) => {
                errorText += `${rowIndex + 1}. ${row.SelfServiceFrameName}.\n`;
            });
            await this.props.dispatch(errorRaised(errorText));
        } else {
            await this.props.dispatch(this.props.sendData.execute());
            this.setState({showMessage: true, messageText: i18next.t("SelfService_1")});
        }
    }

    renderButtons = () => {
        return (<div className="modal-footer">
            <button type="button" className="btn btn-regular -goahead"
                    onClick={this.onSend}>{i18next.t('Send')}</button>
        </div>)
    }

    renderDocument = (row, rowIndex) => {
        return <SelfServiceFrame row={row}/>
    }

    render() {
        if (!this.state.isDataReady)
            return null;
        const rows = this.props.dataItem_List.rawData.DataTable.filter((row) => row.IsView === 1).sort((a, b) => {
            return (a.OrderPos - b.OrderPos);
        });
        return (<ScreenFormatContext.Consumer>
            {
                isDesktop => {
                    return <PlaceholderWrapper placeholderId="10" title={i18next.t('FillData')}>
                        {
                            rows.map((row, rowIndex) => this.renderDocument(row, rowIndex))
                        }
                        {this.renderButtons()}
                        <MessageBox visible={this.state.showMessage}
                                    title={i18next.t('Message')}
                                    messageText={this.state.messageText}
                                    onClose={() => {
                                        this.setState({showMessage: false});
                                    }}
                        />
                    </PlaceholderWrapper>
                }
            }
        </ScreenFormatContext.Consumer>);
    }
}

SelfService.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_List: PropTypes.object
}

SelfService.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_List: state.selfServiceState.SelfServiceFrame_SimpleList,
        sendData: state.selfServiceState.SelfServiceFrame_CheckAndSendData
    }
}

export default connect(mapStateToProps)(SelfService)